<template>
	<v-tooltip bottom v-if="notification && notification.id">
		<template v-slot:activator="{ on, attrs }">
			<v-btn
				class="topbar-action-btn"
				dark
				x-small
				color="#2D4B95"
				v-bind="attrs"
				v-on="on"
				:loading="loading"
				:disabled="loading"
				@click.stop="markAsRead"
			>
				<v-icon dark small>mdi-message-check-outline</v-icon>
			</v-btn>
		</template>
		<span>Cerrar y marcar notificación como leída</span>
	</v-tooltip>
</template>

<script>
import {markNotificationAsReaded} from '@/helpers/api/general'

export default {
	name: 'CloseNotificationButton',
	props: {
		notification: {
			type: Object,
			default: null
		},
		closeModal: {
			type: Function,
			required: true
		}
	},
	data: () => ({
		loading: false
	}),
	methods: {
		async markAsRead(){
			if(this.loading || !this.notification || !this.notification.id) return
			this.loading = true
			this.closeModal()
			try {
				const response = await markNotificationAsReaded({id: this.notification.id})
				if(response.code === 200){
					this.$store.notificationsStore.dispatch('getNotifications')
				}
			} finally {
				this.loading = false
			}
		}
	}
}
</script>

<style scoped>
	.topbar-action-btn {
		display: flex;
		align-items: center;
		justify-content: center;
		height: 24px!important;
		padding: 5px!important;
		min-width: 28px!important;
		aspect-ratio: 1!important;
		border-radius: 6px;
		border: none;
		cursor: pointer;
		transition: opacity 0.15s;
	}
	.topbar-action-btn.big{
		height: 30px!important;
		min-width: 30px!important;
	}
</style>